import { buildRoute } from '@direct-frontend/modules-router';
import { YASTORE_B2B_ROUTE_PATHS } from '@adv-frontend/yastore-modules/routes';

export type SettingsLogisticsWarehouseEdit = { warehouseId: string };
export type SettingsLogisticsSearchParams = { 'active-tab': 'warehouses' | 'services' };
export const SETTINGS_LOGISTICS_SEARCH_PARAMS_WAREHOUSES = {
    'active-tab': 'warehouses',
} satisfies SettingsLogisticsSearchParams;
export const SETTINGS_LOGISTICS_SEARCH_PARAMS_SERVICES = {
    'active-tab': 'services',
} satisfies SettingsLogisticsSearchParams;

export const settingsRoute = buildRoute('/settings');
export const settingsAboutRoute = buildRoute(YASTORE_B2B_ROUTE_PATHS.settingsAbout);
export const settingsLogisticsRoute = buildRoute<never, SettingsLogisticsSearchParams>('/settings/logistics');
export const settingsLogisticsWarehouseEditRoute = buildRoute<SettingsLogisticsWarehouseEdit>(
    '/settings/logistics/warehouse/:warehouseId'
);

export const settingsDomainRoute = buildRoute('/settings/domain');

export const SETTINGS_SEO_SEARCH_PARAM_ACTIVE_TAB = 'active-tab' as const;
export const SETTINGS_SEO_SEARCH_PARAM_SEARCH = 'search' as const;
export const SETTINGS_SEO_SEARCH_PARAM_PAGE = 'page' as const;
export const SETTINGS_SEO_SEARCH_PARAM_SORT_BY = 'sortBy' as const;
export const SETTINGS_SEO_SEARCH_PARAM_SORT_ORDER = 'sortOrder' as const;

export const SETTINGS_SEO_TAB_KEYS = {
    REDIRECTS: 'redirects',
    TEMPLATES: 'templates',
    SITE_VERIFICATION: 'site-verification',
    ROBOTS: 'robots',
    KEYWORDS: 'keywords',
    ERRORS: 'errors',
} as const;

export type SettingsSeoSearchParams =
    | {
          [SETTINGS_SEO_SEARCH_PARAM_ACTIVE_TAB]: typeof SETTINGS_SEO_TAB_KEYS.REDIRECTS;
          [SETTINGS_SEO_SEARCH_PARAM_SEARCH]?: string;
          [SETTINGS_SEO_SEARCH_PARAM_PAGE]?: number;
      }
    | { [SETTINGS_SEO_SEARCH_PARAM_ACTIVE_TAB]: typeof SETTINGS_SEO_TAB_KEYS.TEMPLATES }
    | { [SETTINGS_SEO_SEARCH_PARAM_ACTIVE_TAB]: typeof SETTINGS_SEO_TAB_KEYS.SITE_VERIFICATION }
    | { [SETTINGS_SEO_SEARCH_PARAM_ACTIVE_TAB]: typeof SETTINGS_SEO_TAB_KEYS.ROBOTS }
    | { [SETTINGS_SEO_SEARCH_PARAM_ACTIVE_TAB]: typeof SETTINGS_SEO_TAB_KEYS.ERRORS }
    | {
          [SETTINGS_SEO_SEARCH_PARAM_ACTIVE_TAB]: typeof SETTINGS_SEO_TAB_KEYS.KEYWORDS;
          [SETTINGS_SEO_SEARCH_PARAM_SEARCH]?: string;
          [SETTINGS_SEO_SEARCH_PARAM_PAGE]?: number;
          [SETTINGS_SEO_SEARCH_PARAM_SORT_BY]?: string;
          [SETTINGS_SEO_SEARCH_PARAM_SORT_ORDER]?: string;
      };

export const settingsSeoRoute = buildRoute<never, SettingsSeoSearchParams>('/settings/seo');
export const settingsPaymentRoute = buildRoute('/settings/payment');
export const settingsProductFeedRoute = buildRoute('/settings/feed');
export const settingsOtherRoute = buildRoute('/settings/other');
export const settingsManagersRoute = buildRoute('/settings/managers');
/** Гранулы */
export const SETTINGS_INVENTORY_SEARCH_PARAM_ACTIVE_TAB = 'active-tab' as const;
export const SETTINGS_INVENTORY_SEARCH_PARAM_INTEGRATION = 'integration' as const;
export type SettingsInventoryActiveTab = 'main' | 'sources';
export const SETTINGS_INVENTORY_SEARCH_PARAM_ACTIVE_TAB_MAP: Record<
    SettingsInventoryActiveTab,
    SettingsInventoryActiveTab
> = {
    main: 'main',
    sources: 'sources',
};
export const SETTINGS_INVENTORY_INTEGRATION_MAP = {
    wildberries: 'wildberries',
    ozon: 'ozon',
    yandex_market: 'yandex_market',
    moysklad: 'moysklad',
    yml: 'yml',
} as const;
export type SettingsInventoryIntegration =
    (typeof SETTINGS_INVENTORY_INTEGRATION_MAP)[keyof typeof SETTINGS_INVENTORY_INTEGRATION_MAP];
export const isSettingsInventoryIntegration = (
    integration: string | null
): integration is SettingsInventoryIntegration =>
    Boolean(
        integration &&
            Object.values(SETTINGS_INVENTORY_INTEGRATION_MAP).includes(integration as SettingsInventoryIntegration)
    );
export type SettingsInventorySearchParams = {
    [SETTINGS_INVENTORY_SEARCH_PARAM_ACTIVE_TAB]?: SettingsInventoryActiveTab;
    [SETTINGS_INVENTORY_SEARCH_PARAM_INTEGRATION]?: SettingsInventoryIntegration;
};
export const SETTINGS_INVENTORY_SEARCH_PARAMS_SOURCES = {
    [SETTINGS_INVENTORY_SEARCH_PARAM_ACTIVE_TAB]: SETTINGS_INVENTORY_SEARCH_PARAM_ACTIVE_TAB_MAP.sources,
} satisfies SettingsInventorySearchParams;
export const settingsInventoryRoute = buildRoute<never, SettingsInventorySearchParams>('/settings/inventory');
export const settingsInventorySourcesTabUrl = settingsInventoryRoute.getUrl({
    searchParams: SETTINGS_INVENTORY_SEARCH_PARAMS_SOURCES,
});

export const settingsYcpRoute = buildRoute('/settings/ycp');
export const SETTINGS_INTEGRATIONS_SEARCH_PARAM_ACTIVE_TAB = 'active-tab' as const;
export const SETTINGS_INTEGRATIONS_TAB_KEYS = {
    ALL: 'all',
    CONNECTED: 'connected',
} as const;
export type SettingsIntegrationsTabKey =
    (typeof SETTINGS_INTEGRATIONS_TAB_KEYS)[keyof typeof SETTINGS_INTEGRATIONS_TAB_KEYS];
export type SettingsIntegrationsSearchParams = {
    [SETTINGS_INTEGRATIONS_SEARCH_PARAM_ACTIVE_TAB]?: SettingsIntegrationsTabKey;
};
export const SETTINGS_INTEGRATIONS_SEARCH_PARAMS_CONNECTED = {
    [SETTINGS_INTEGRATIONS_SEARCH_PARAM_ACTIVE_TAB]: SETTINGS_INTEGRATIONS_TAB_KEYS.CONNECTED,
} satisfies SettingsIntegrationsSearchParams;
export const settingsIntegrationsRoute = buildRoute<never, SettingsIntegrationsSearchParams>('/settings/integrations');
export const settingsYaMetrikaRoute = buildRoute('/settings/metrika');
export const settingsBuyButtonRoute = buildRoute('/settings/buy-button');
export const settingsOrderRoute = buildRoute('/settings/order');

export const settingsFeedbackRoute = buildRoute('/settings/feedback');
export const settingsApiRoute = buildRoute('/settings/api');
export const settingsEmailNotificationsRoute = buildRoute('/settings/email-notifications');
export const settingsTestOrderRoute = buildRoute('/settings/test-order');
